import { SUBMIT_MORE_DETAILS_FORM } from './constants'

export function submitMoreDetailsForm(formValues) {
  return {
    type: SUBMIT_MORE_DETAILS_FORM,
    formValues,
  }
}
